import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import LazyLoading from '../../../components/LazyLoading';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';

import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

import { Society } from '../../../app/models/Society';
import { Provider } from '../../../app/models/Provider';
import { useHistory } from 'react-router-dom';
import { TruckDataForm, defaultTruckDataForm } from '../../../app/models/Truck';
import useTruckService from '../../../app/services/hooks/useTruckService';
import { Brand } from '../../../app/models/Brand';
import { VehicleModel } from '../../../app/models/VehicleModel';
import useHopperService from '../../../app/services/hooks/useHopperService';
import { HopperDataForm, defaultHopperDataForm } from '../../../app/models/Hopper';
import HopperForm from './forms/HopperForm';
import useNavigationPage from '../../../hooks/useNavigationPage';
import { DocumentSet } from '../../../app/models/DocumentSet';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const HopperCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const history = useHistory();
    const { navigationPage } = useNavigationPage();

    const [societies, setSocieties] = useState<Society[]>([]);
    const [providers, setProviders] = useState<Provider[]>([]);
    const [brands, setBrands] = useState<Brand[]>([]);
    const [vehicleModels, setVehicleModels] = useState<VehicleModel[]>([]);
    const [documentSets, setDocumentSets] = useState<DocumentSet[]>([]);
    const [hopper, setHopper] = useState<HopperDataForm>(defaultHopperDataForm);

    const [errorFields, setErrorFields] = useState<any>();

    const { fetchingCreateHopper, fetchingStoreHopper, createHopper, storeHopper } =
        useHopperService();

    useEffect(() => {
        if (showLoading) showLoading('loading', 'Cargando datos...');

        createHopper({
            onSuccess: (response: ServiceResponse) => {
                setSocieties(response.data.societies);
                setProviders(response.data.providers);
                setBrands(response.data.brands);
                setVehicleModels(response.data.vehicle_models);
                setDocumentSets(response.data.document_sets);
                setHopper(defaultHopperDataForm);

                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    }, []);

    useEffect(() => {
        if (hopper?.is_internal == true) {
            setHopper({
                ...hopper,
                society_id: 0,
                provider_id: undefined,
                is_internal: true
            });
        } else if (hopper?.is_internal == false) {
            setHopper({
                ...hopper,
                provider_id: 0,
                society_id: undefined,
                is_internal: false
            });
        }
    }, [hopper?.is_internal]);

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando Semi Remolque...');
        storeHopper(hopper, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                navigationPage('/hoppers/' + response.data.hopper_id + '/edit');
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    // if (errorGetData !== '') {
    //     return <div>{errorGetData}</div>;
    // }

    return fetchingCreateHopper ? (
        <LazyLoading height={300} />
    ) : (
        <>
            <div className="row">
                <div className="col-12">
                    <HopperForm
                        hopperForm={hopper}
                        setHopperForm={setHopper}
                        societies={societies}
                        providers={providers}
                        brands={brands}
                        vehicleModels={vehicleModels}
                        documentSets={documentSets}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStoreHopper} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreHopper} />
                </div>
            </div>
        </>
    );
};

export default HopperCreate;
